<template>
  <div>
    <Drag v-for="(item, ind) in items" :key="ind" @drag-start="dragStart($event, ind)" @dragging="dragging" @drag-stop="dragStop">
      <span ref="draggingItem">
        <slot name="items" :item="item" />
      </span>
    </Drag>
  </div>
</template>

<script>
import Drag from './Drag.vue'
export default {
  components: { Drag },
  props: ['items'],
  data() {
    return {
      draggingElement: null,
      startPosition: null,
    };
  },
  methods: {
    dragStart(event, ind) {
      var element = this.$refs.draggingItem[ind];
      this.draggingElement = element.cloneNode(true);
      this.draggingElement.style.position = 'fixed';

      const { x, y, width, height } = element.getBoundingClientRect();

      this.draggingElement.style.width = `${width}px`;
      this.draggingElement.style.height = `${height}px`;
      this.draggingElement.style.left = `${x}px`;
      this.draggingElement.style.top = `${y}px`;
      this.draggingElement.style.zIndex = 9999;
      this.$el.appendChild(this.draggingElement);

      this.startPosition = { x, y: y - height };
      this.$emit('input', this.items[ind]);
    },
    dragging(event) {
      if (!this.draggingElement) return;
      this.draggingElement.style.left = `${event.x + this.startPosition.x}px`;
      this.draggingElement.style.top = `${event.y + this.startPosition.y + this.draggingElement.offsetHeight}px`;
    },
    dragStop() {
      if (!this.draggingElement) return;
      this.draggingElement.parentElement.removeChild(this.draggingElement);
      this.draggingElement = null;
      this.$emit('input', null);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisDragZone'] = this;
  },
}
</script>